<template>
  <div class="layout">
    <nav-bar></nav-bar>
    <main class="layout-main">
      <router-view></router-view>
    </main>
  </div>
</template>

<script lang="ts">
import NavBar from '@/components/navigation/desktop/NavBar.vue'
import Vue from 'vue'
export default Vue.extend({
  name: 'InfoLayout',

  components: { NavBar }
})
</script>

<style lang="sass" scoped>
body
  margin: 0px
  padding: 0px
  width: 100%
  height: 100%

.layout
  min-height: 100vh
  width: 100%

.layout-main
  height: 100%
</style>
